<template>
  <div class="container mx-auto mt-6 p-4 rounded flex flex-col gap-5 bg-base-300">
    <details class="collapse collapse-arrow border-gray-300 border  bg-white">
      <summary class="collapse-title text-3xl font-medium mb-2">Buttons</summary>
      <div class="collapse-content"><!--Buttons-->
        <div>colors</div>
        <div class="flex gap-5 mb-3">
          <AButton class="btn-neutral" @click="button1"/>
          <AButton class="btn-primary btn-xs" :left="FlagIcon"/>
          <AButton class="btn-secondary"/>
          <AButton class="btn-accent"/>
          <AButton class="btn-success"/>
          <AButton class="btn-warning"/>
          <AButton class="btn-error"/>
        </div>
        <template v-for="i in ['','btn-outline','btn-soft','btn-ghost']">
          <label>{{i ? i : 'normal'}}</label>
          <template v-for="j in ['', 'Primary','Secondary','Accent','Success','Warning','Error']">
            <div class="flex gap-5 mb-3">
              <template v-for="k in ['xs','sm','','lg', 'xl']">
                <AButton :class="[j?`btn-${j.toLowerCase()}`:'',i,k?`btn-${k}`:'']" :left="lagIcon" :right="FlagIcon">
                  {{j ? j : 'Default'}} {{k ? k.toUpperCase() : ''}}
                </AButton>
              </template>
            </div>
          </template>
        </template>
      </div>
    </details>
    <!--Icons-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Icons</summary>
      <div class="collapse-content">
        <div class="flex gap-5 mb-3">

          <CardIcon class="blue"/>
          <CardIcon class="yellow"/>
          <CardIcon class="green"/>
          <CardIcon class="red"/>
          <CardIcon class="light"/>

          <CardIcon class="blue sm"/>
          <CardIcon class="yellow sm"/>
          <CardIcon class="green sm"/>
          <CardIcon class="red sm"/>
          <CardIcon class="orange sm" label="Warning"/>
        </div>

      </div>
    </details>

    <!--Flight Routes -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Flight Routes</summary>
      <div class="collapse-content">
        <div class="flex flex-col gap-5">
          <FlightLeg
              :initial="getSegmentLabel({ iata_code: 'CDG', city: 'Paris' })"
              :final="getSegmentLabel({ iata_code: 'MAD', city: 'Madrid' })"
              :initial-label="formatSmartLocal('2025-06-16T00:00:00Z')"
              :final-label="formatSmartLocal('2025-06-16T00:00:00Z')"
              status="updated"
          >
            <TypeOfFlightIcon type="multiple" :color="getFlightStatusColor('updated')"
                              topText="Type of Flight"
                              bottomText='multiple'
            />
          </FlightLeg>

        </div>

        <div class="flex flex-col gap-5">
          <FlightLeg
              :initial="getSegmentLabel({ iata_code: 'CDG', city: 'Paris' })"
              :final="getSegmentLabel({ iata_code: 'MAD', city: 'Madrid' })"
              :initial-label="formatSmartLocal('2025-06-16T00:00:00Z', 'Europe/Paris')"
              :final-label="formatSmartLocal('2025-06-16T00:00:00Z', 'Europe/Madrid')"
              status="updated"
              reduced
          >
            <CompactTypeOfFlightIcon type="multiple" :color="getFlightStatusColor('updated')"/>
          </FlightLeg>
        </div>
      </div>
    </details>

    <!--Dangerous Goods-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Dangerous Goods</summary>
      <div class="collapse-content">
        <div class="flex flex-wrap gap-2">
          <div v-for="item in DANGEROUS_GOODS_CODES.map(i=> i.value)">
            <img :src="getDangerousGoodIcon(item)" class="h-12 w-12" :alt="item">
          </div>

        </div>

      </div>
    </details>
    <!--DataDisplay-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Data Display</summary>
      <div class="collapse-content"><!--Icons-->
        <DataDisplay/>

      </div>
    </details>

    <!--SectionDivider-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Section Divider</summary>
      <SectionDivider title="Flight Route" icon="bi-airplane"/>
      <SectionDivider title="Additional Details" icon="bi-list"/>
      <SectionDivider title="Product Details" icon="bi-box"/>
      <SectionDivider title="Good Details" icon="bi-file-bar-graph"/>
    </details>

    <!--StepIndicator-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Step Indicator</summary>
      <div class="collapse-content">
        <Steps v-model="steps" :currentStep="1" icon/>
      </div>
    </details>

    <!--Selection Button Group-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Selection Button Group</summary>
      <div class="collapse-content">

        <FormLabel label="Single select" required/>
        <SelectionButtonGroup
            v-model="flightType"
            :options=flightTypes
            padding="px-12"
        />

        <FormLabel label="Multi select" required/>
        <SelectionButtonGroup
            v-model="flightClass"
            multiple
            :options=flightClasses
        />
      </div>
    </details>

    <!--Custom Dropdown-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Custom Dropdown</summary>
      <div class="collapse-content">

        <!-- Aircraft Dropdown -->
        <FormLabel label="Aircraft" required/>
        <CustomDropdown
            class="p-2"
            ref="aircraftDropdown"
            :model-value="aircraft"
            placeholder="Select aircraft type"
            leftIcon="bi-airplane"
            clearable
            @clear="aircraft = ''"
        >
          <ul>
            <li
                v-for="item in ['Airbus A320', 'Boeing 737']"
                :key="item"
                class="px-4 py-2 hover:bg-base-200 cursor-pointer"
                @click="() => { aircraft = item; aircraftDropdown?.close() }"
            >
              {{item}}
            </li>
          </ul>
        </CustomDropdown>

        <!-- Location Dropdown -->
        <FormLabel label="Origin" required/>
        <CustomDropdown
            class="p-2"
            ref="locationDropdown"
            :model-value="origin"
            placeholder="Select origin"
            leftIcon="bi-geo-alt"
            clearable
            @clear="origin = ''"
        >
          <div class="p-2">
            <input
                v-model="locationQuery"
                placeholder="Search location..."
                class="input input-bordered w-full mb-2"
            />
            <ul>
              <li
                  v-for="loc in filteredLocations"
                  :key="loc"
                  class="px-4 py-2 hover:bg-base-200 cursor-pointer"
                  @click="() => { origin = loc; locationDropdown?.close() }"
              >
                {{loc}}
              </li>
            </ul>
          </div>
        </CustomDropdown>

        <!-- Date Picker Dropdown -->
        <FormLabel label="Date" required/>
        <CustomDropdown
            class="p-2"
            ref="dateDropdown"
            :model-value="selectedDateText"
            placeholder="Select date"
            rightIcon="bi-calendar"
            clearable
            @clear="clearDate"
        >

          <VueDatePicker
              v-model="selectedDate"
              inline
              color="primary"
              :teleport="true"
              input-class="input input-bordered w-full"
              menu-class="bg-base-100 p-4 rounded-box shadow"
              calendar-cell-class="rounded-md hover:bg-primary hover:text-primary-content"
              calendar-cell-selected-class="bg-primary text-primary-content"
              @update:model-value="dateDropdown?.close()"
          />
        </CustomDropdown>

      </div>
    </details>

    <!--Section Box-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Section Box</summary>
      <div class="collapse-content">
        <SectionBox title="Piece details" icon="bi-puzzle">
          <!-- your form content here -->
          <div class="grid gap-4">
            <label class="label">Piece description</label>
          </div>
        </SectionBox>
      </div>
    </details>

    <!--StepperInput-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Stepper Input</summary>

      <div class="collapse-content">
        <FormLabel label="Quantity" required/>
        <StepperInput v-model="quantity" :min="0" :max="10"/>
      </div>
    </details>

    <!--Labeled Input-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Labeled Input</summary>
      <div class="collapse-content">
        <FormLabel label="Weight" required/>
        <LabeledInput :units="weightUnits" v-model="weight" v-model:unit="dimensionWeightUnit"/>

        <FormLabel label="Volume" required/>
        <LabeledInput :units="volumeUnits" v-model="volume" v-model:unit="dimensionVolumeUnit"/>

        <FormLabel label="Length" required/>
        <LabeledInput :units="distanceUnits" v-model="distance" v-model:unit="dimensionDistanceUnit"/>

      </div>
    </details>

    <!--Text Input -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Text Input</summary>
      <div class="collapse-content"><!--Icons-->
        <FormLabel label="Piece description" required/>
        <CustomTextInput v-model="pieceDescription"/>
      </div>
    </details>

    <!--Text Area -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Text Area</summary>
      <div class="collapse-content">
        <FormLabel label="Piece long description"/>
        <CustomTextArea v-model="textArea"/>
      </div>
    </details>

    <!--File Upload-->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">File Upload</summary>
      <div class="collapse-content">


        <FileUploadBox
            accept="image/*"
            accept-text="JPG, PNG, SVG — drag or select"
            @file-selected="handleNewFile"
            @file-removed="handleRemovedFile"
        />
      </div>
    </details>

    <!--Add Product Button -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Add Product Button</summary>
      <div class="collapse-content">

        <AddProductButton @click="addProduct"/>
      </div>
    </details>

    <!--Airline Selector -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Airline Selector</summary>
      <div class="collapse-content">
        <AirlineSelector/>
      </div>
    </details>

    <details class="collapse collapse-arrow border border-gray-300 bg-white p-4 space-y-4" open="">
      <summary class="collapse-title text-3xl font-medium">Disclaimers</summary>

      <DisclaimersGroup @add-product="handleProductAdded"/>
    </details>


    <details class="collapse collapse-arrow border border-gray-300 bg-white p-4 space-y-4" open="">
      <summary class="collapse-title text-3xl font-medium">Toasts</summary>
      <div class="collapse-content flex gap-4">
        <AButton class="btn-info" @click="showInfo('Info')">Show Info Toast</AButton>
        <AButton class="btn-success" @click="showSuccess('Success')">Show Success Toast</AButton>
        <AButton class="btn-warning" @click="showWarning( 'Warning')">Show Warning Toast</AButton>
        <AButton class="btn-error" @click="showError( 'Error')">Show Error Toast</AButton>
      </div>
    </details>

    <!--Flight Autocomplete (SerpApi) -->
    <details class="collapse collapse-arrow border-gray-300 border bg-white overflow-visible" open="">
      <summary class="collapse-title text-3xl font-medium mb-2">Flight Autocomplete</summary>

      <div class="collapse-content overflow-visible">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Origin -->
          <div class="space-y-2">
            <FormLabel label="Origin (Autocomplete)" required/>
            <FlightLocationAutocomplete
                v-model="originSelection"
                placeholder="Search airport, city..."
                :min-chars="2"
            />
          </div>

          <!-- Destination -->
          <div class="space-y-2">
            <FormLabel label="Destination (Autocomplete)" required/>
            <FlightLocationAutocomplete
                v-model="destinationSelection"
                placeholder="Search airport, city..."
                :min-chars="2"
            />
          </div>
        </div>
      </div>
    </details>

  </div>
</template>

<script setup>
import AButton from "@/components/atoms/AButton.vue";
import {FlagIcon} from '@heroicons/vue/24/outline'
import CardIcon from "@/components/atoms/CardIcon.vue";
import DataDisplay from "@/components/molecules/DataDisplay.vue";
import SectionDivider from "@/components/atoms/SectionDivider.vue";
import Steps from "@/components/molecules/Steps.vue";
import SelectionButtonGroup from "@/components/organisms/SelectionButtonGroup.vue";
import {computed, ref} from "vue";
import CustomDropdown from "@/components/molecules/CustomDropdown.vue";
import VueDatePicker from '@vuepic/vue-datepicker'
import SectionBox from "@/components/molecules/SectionBox.vue";
import StepperInput from "@/components/molecules/StepperInput.vue";
import LabeledInput from "@/components/molecules/LabeledInput.vue";
import CustomTextInput from "@/components/molecules/CustomTextInput.vue";
import FormLabel from "@/components/atoms/FormLabel.vue";
import CustomTextArea from "@/components/molecules/CustomTextArea.vue";
import FileUploadBox from "@/components/organisms/FileUploadBox.vue";
import AddProductButton from "@/components/molecules/AddProductButton.vue";
import AirlineSelector from "@/components/organisms/AirlineSelector.vue";
import DisclaimersGroup from "@/components/organisms/DisclaimersGroup.vue";
import {
  getDangerousGoodIcon,
  getFlightStatusColor,
  getSegmentLabel,
  showError,
  showInfo,
  showSuccess,
  showWarning
} from "@/common/functions.js";
import {DANGEROUS_GOODS_CODES} from "@/common/constants.js";
import {formatSmartLocal} from "@/common/dates.js";
import TypeOfFlightIcon from "@/components/atoms/TypeOfFlightIcon.vue";
import FlightLeg from "@/components/molecules/FlightLeg.vue";
import CompactTypeOfFlightIcon from "@/components/atoms/CompactTypeOfFlightIcon.vue";
import FlightLocationAutocomplete from "@/components/organisms/FlightLocationAutocomplete.vue";

const originSelection = ref(null)
const destinationSelection = ref(null)

// OPTIONAL: if you want a nice label for old fields
const originSelectionLabel = computed(() => originSelection.value?.label ?? "")
const destinationSelectionLabel = computed(() => destinationSelection.value?.label ?? "")

// OPTIONAL: bridge to your existing "origin" string (for your old demo dropdown)
function applyAutocompleteToLegacyOrigin() {
  origin.value = originSelection.value?.label ?? ""
}

const flightTypes = [
  {value: 'simple', label: 'Simple', left: 'bi-airplane'},
  {value: 'multiple', label: 'Multiple', left: 'bi-airplane-engines'}
]
const flightClasses = [
  {value: 'general', label: 'General', left: 'bi-box'},
  {value: 'special', label: 'Special', left: 'bi-bounding-box'}
]

const flightType = ref('simple')
const flightClass = ref(['general'])

const aircraft = ref('')
const origin = ref('')
const selectedDate = ref(null)
const aircraftDropdown = ref()
const locationDropdown = ref()
const dateDropdown = ref()
const quantity = ref(0)
const weight = ref(0)
const volume = ref(0)
const distance = ref(0)
const pieceDescription = ref('')
const textArea = ref('')

const weightUnits = [
  {unit: 'kg', labelUnit: 'Kg'},
  {unit: 'lb', labelUnit: 'Lb'},
  {unit: 'ton', labelUnit: 'Ton'}
]

const volumeUnits = [
  {unit: 'cbm', labelUnit: 'm³'},
  {unit: 'cbcm', labelUnit: 'cm³'},
  {unit: 'cuin', labelUnit: 'in³'},
  {unit: 'cuft', labelUnit: 'ft³'},
]

const distanceUnits = [
  {unit: 'cm', labelUnit: 'cm'},
  {unit: 'm', labelUnit: 'm'},
  {unit: 'km', labelUnit: 'km'},
]
const dimensionWeightUnit = ref(weightUnits[0].unit)
const dimensionVolumeUnit = ref(volumeUnits[0].unit)
const dimensionDistanceUnit = ref(distanceUnits[0].unit)

const locationQuery = ref('')
const locations = ['Amsterdam', 'London', 'New York', 'Tokyo', 'Berlin']

const filteredLocations = computed(() =>
    locations.filter(loc => loc.toLowerCase().includes(locationQuery.value.toLowerCase()))
)

const selectedDateText = computed(() =>
    selectedDate.value
        ? new Date(selectedDate.value).toLocaleDateString()
        : ''
)
const steps = ref([
  {label: 'General data', description: 'Date, Origin, Destination...'},
  {label: 'Goods description', description: 'Commodities, Product Type, Piece Details...'},
  {label: 'Submitted request', description: 'Send your request to charterer.'},
])

function clearDate() {
  selectedDate.value = null
}

const button1 = () => {
  alert('Button 1 clicked');
}

function handleNewFile(file) {
  console.log('Added:', file.name)
}

function handleRemovedFile(file) {
  console.log('Removed:', file.name)
}

const disclaimerList = [
  {
    name: 'Disclaimers name',
    count: 5,
    items: [
      'This quote is conditional',
      'Subject to approval',
      'Limited to 30 days',
      'Taxes not included',
      'Valid only in EU',
    ]
  },
  {
    name: 'General Disclaimers',
    count: 4,
    items: [
      'May vary depending on aircraft',
      'Subject to fuel price adjustments',
      'Availability is not guaranteed',
      'No liability for delays',
    ]
  },
  {
    name: 'Main options',
    count: 2,
    items: [
      'Standard conditions apply',
      'Optional services not included',
    ]
  },
  {
    name: 'From Europa request',
    count: 2,
    items: [
      'Request must be validated',
      'Subject to approval by EU charter office',
    ]
  },
  {
    name: 'Disclaimers with AI',
    count: 2,
    items: [
      'AI-generated recommendations only',
      'Manual validation required',
    ]
  },
  {
    name: 'Total request',
    count: 2,
    items: [
      'Final quote must include fuel',
      'Subject to loadmaster confirmation'
    ]
  }
]

function handleProductAdded() {
  console.log('AddProductButton clicked — no disclaimers selected.')
}

</script>
